import { lazy } from 'react';

const CustomerView = lazy(() => import('./CustomerView'));

export default CustomerView;
